import { createClient } from "@supabase/supabase-js";

// Utiliser uniquement les variables VITE_ du fichier .env principal
const supabaseUrl = typeof import.meta !== 'undefined' && import.meta.env ? import.meta.env.VITE_SUPABASE_URL : undefined;
const supabaseKey = typeof import.meta !== 'undefined' && import.meta.env ? import.meta.env.VITE_SUPABASE_ANON_KEY : undefined;

// Configuration simplifiée
const supabaseOptions = {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: false
  },
  global: {
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  }
};

// Vérification de la configuration
if (!supabaseUrl || !supabaseKey) {
  console.error('Configuration Supabase manquante. Vérifiez votre fichier .env');
  console.error('Variables requises: VITE_SUPABASE_URL, VITE_SUPABASE_ANON_KEY');
}

export const supabase = supabaseUrl && supabaseKey ? createClient(supabaseUrl, supabaseKey, supabaseOptions) : null;
